import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SlotTime } from "../../types/slots.types";
import { getSlots, lockSlot, unlockSlot } from "../../services/slotService";
import { setSelectedCity } from "./citySlice";

interface SlotState {
  _id: string;
  city: string;
  country: string;
  date: string;
  slotTimes: SlotTime[];
  lockedSlot?: SlotTime;
}

const initialState: SlotState = {
  _id: "",
  city: "",
  country: "",
  date: "",
  slotTimes: [],
  lockedSlot: undefined,
};

export const fetchSlots = createAsyncThunk(
  "slot/getSlots",
  async (
    { city, country, date }: { city: string; country: string; date: string },
    { rejectWithValue }
  ) => {
    const { data, error } = (await getSlots(city, country, date)) as {
      data: SlotState;
      error: any;
    };

    if (error) return rejectWithValue(error);

    return {
      data,
    };
  }
);

export const slotLocking = createAsyncThunk(
  "slot/lockSlot",
  async (
    {
      city,
      country,
      date,
      slotTime,
      previousSlotTime,
    }: {
      city: string;
      country: string;
      date: string;
      slotTime: string;
      previousSlotTime?: string;
    },
    { rejectWithValue }
  ) => {
    const { data, error } = (await lockSlot(
      city,
      country,
      date,
      slotTime,
      previousSlotTime
    )) as any;

    if (error) return rejectWithValue(error);
    return { data };
  }
);

export const slotUnlocking = createAsyncThunk(
  "slot/unlockSlot",
  async (
    {
      city,
      country,
      date,
      slotTime,
    }: { city: string; country: string; date: any; slotTime: string },
    { rejectWithValue }
  ) => {
    const { data, error } = await unlockSlot(city, country, date, slotTime);

    if (error) return rejectWithValue(error);
    return { data };
  }
);

export const slotSlice = createSlice({
  name: "slot",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSlots.fulfilled, (state, action) => {
      state._id = action.payload.data._id;
      state.city = action.payload.data.city;
      state.country = action.payload.data.country;
      state.date = action.payload.data.date;
      state.slotTimes = action.payload.data?.slotTimes;
    });
    builder.addCase(slotLocking.fulfilled, (state, action) => {
      state.slotTimes = action.payload.data?.slotTimes;
      state.lockedSlot = action.payload.data?.lockedSlot;
    });
    builder.addCase(slotUnlocking.fulfilled, (state, action) => {
      state.lockedSlot = undefined;
    });
    builder.addCase(setSelectedCity, (state, action) => {
      state._id = "";
      state.city = "";
      state.country = "";
      state.date = "";
      state.slotTimes = [];
      state.lockedSlot = undefined;
    });
  },
});

export default slotSlice.reducer;
